import { Youtube, Newspaper } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="mt-16 border-t border-slate-200 bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-6 px-4 py-10 md:flex-row md:items-end md:justify-between md:px-6">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">Oreun Academy</h2>
          <p className="mt-1 text-sm text-slate-500">투자의 기준을 세우는 학습 플랫폼</p>
          <div className="mt-4 flex items-center gap-2">
            <a
              href="https://www.youtube.com/@stocksmentor"
              target="_blank"
              rel="noreferrer"
              className="rounded-full border border-slate-200 bg-white p-2 text-slate-600 transition hover:border-red-200 hover:text-red-500"
              aria-label="youtube"
            >
              <Youtube className="h-4 w-4" />
            </a>
            <a
              href="https://www.daily-m.tv/"
              target="_blank"
              rel="noreferrer"
              className="rounded-full border border-slate-200 bg-white p-2 text-slate-600 transition hover:border-blue-200 hover:text-blue-500"
              aria-label="news"
            >
              <Newspaper className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="space-y-1 text-xs text-slate-500 md:text-right">
          <p>(주)오른아카데미 Copyright © 2025 Oreun Academy. All rights reserved.</p>
          <p>사업자등록번호: 470-81-03597 | 대표원장: 정태영</p>
          <p>세종시 갈매로 351 에비뉴힐A동 5009호 | 이메일: mptai12@naver.com</p>
          <p>대표연락처: 044-715-5544, 010-2394-3086</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
